export const labPtBr = {
  title: 'Laboratório',
  entity: {
    label: 'Entidade',
    all: 'Todas as entidades',
  },
  greeting: {
    morning: 'Bom dia, {{name}}',
    afternoon: 'Boa tarde, {{name}}',
    evening: 'Boa noite, {{name}}',
    morningGeneric: 'Bom dia',
    afternoonGeneric: 'Boa tarde',
    eveningGeneric: 'Boa noite',
  },
  closing: {
    unavailable: 'Fechamento sem indicador',
    title: 'Itens lançados, classificados e conciliados no mês',
  },
  summary: {
    solved_one: 'Você resolveu <strong>{{count}}</strong> pendência em {{month}}.',
    solved_other: 'Você resolveu <strong>{{count}}</strong> pendências em {{month}}.',
    remaining_one: 'Falta <strong>{{count}}</strong>.',
    remaining_other: 'Faltam <strong>{{count}}</strong>.',
    pending_one: '<strong>{{count}}</strong> pendência aguarda você.',
    pending_other: '<strong>{{count}}</strong> pendências aguardam você.',
    none: 'Nada pendente.',
  },
  score: {
    loading: 'Carregando o placar do mês',
    title: 'Pendências resolvidas no mês',
    label: '{{solved}} de {{total}}',
    period: 'pendências resolvidas em {{month}}',
    none: 'Nada pendente',
    unavailable: 'Placar indisponível',
  },
  flow: {
    title: 'Mês atual',
    loading: 'Carregando o fluxo',
    sourceHeading: 'O que chegou',
    stageHeading: 'Em processamento',
    outputHeading: 'Virou ouro',
    outputDetail: 'Lançados e conciliados',
    outputAmount: '{{amount}} conciliados em extratos e cartões',
    pending: 'precisam de você',
    nonePending: 'Nada parado com você',
    unavailable: 'Dado indisponível',
    error: 'Não foi possível carregar o fluxo.',
    sources: {
      bank: 'Extratos bancários',
      cards: 'Cartões corporativos',
      email: 'E-mail',
      invoices: 'Notas fiscais',
      dda: 'Boletos DDA',
    },
    stages: {
      reading: 'Lendo',
      classifying: 'Classificando',
      reconciling: 'Conciliando',
      ignored: 'Descartados',
    },
    details: {
      descriptions: {
        reading: 'Chegou, mas ainda não virou conta.',
        classifying: 'Já virou conta, mas a conta ainda não foi aprovada.',
        reconciling: 'Movimento de extrato ou cartão ainda sem par.',
        ignored: 'Ignorado, rejeitado, cancelado ou anulado. Não há nada a fazer.',
      },
      readingEmail: 'A Alquimia ainda está lendo estes e-mails.',
      classifyingEmail: 'Inclui e-mails que esperam a resposta do remetente.',
      links: {
        receivedNfs: 'Abrir notas fiscais recebidas',
        ddaInbox: 'Abrir caixa de entrada DDA',
        drafts: 'Abrir contas em rascunho',
        forApproval: 'Abrir contas em aprovação',
        pendingLines: 'Abrir movimentos pendentes',
        suggestions: 'Abrir sugestões de conciliação',
      },
    },
  },
  decisions: {
    title: 'Precisa de você',
    loading: 'Carregando suas pendências',
    allEntities: 'Mostra as decisões de todas as entidades.',
    emptyTitle: 'Tudo resolvido',
    emptyDescription: 'Não há pendências aguardando você agora.',
    error: 'Não foi possível carregar suas pendências.',
    count_one: '{{count}} decisão',
    count_other: '{{count}} decisões',
    openList_one: 'Ver a decisão em lista',
    openList_other: 'Ver as {{count}} decisões em lista',
    listDescription: 'Tudo que aguarda uma decisão sua, com as ações rápidas de cada item.',
    listDescriptionWithAgent:
      'Tudo que aguarda uma decisão sua, menos as propostas do agente, que ficam nos cartões.',
    more: 'Ver todas em Pendências',
    moreEmails_one: 'Carregar mais 1 e-mail',
    moreEmails_other: 'Carregar mais {{count}} e-mails',
    moreEmailsFailed: 'Não foi possível carregar mais e-mails. Tente de novo.',
    position: '{{current}} de {{total}}',
    openPendingList: 'Ver as {{total}} pendências em lista, com ações em lote',
    pendingListTitle: 'Pendências',
    pendingListDescription: 'Aprove ou recuse várias pendências de uma vez.',
    previous: 'Pendência anterior',
    next: 'Próxima pendência',
    approve: 'Aprovar',
    approveShortcut: 'A',
    open: 'Abrir',
    reviewInPendencias: 'Decidir em Pendências',
    dueOn: 'Vence em {{date}}',
    genericError: 'Não foi possível concluir. Tente de novo.',
    bill: {
      untitled: 'Conta a pagar',
      number: 'Nota {{number}}',
      alerts_one: '{{count}} alerta nesta conta',
      alerts_other: '{{count}} alertas nesta conta',
      hasWarnings:
        'Esta conta tem avisos para conferir antes de aprovar. Abra a conta para decidir.',
      open: 'Abrir conta',
      ask: 'Precisa da sua aprovação',
      facts: {
        glAccount: 'Conta contábil',
        managerialAccount: 'Conta gerencial',
        costCenter: 'Centro de custo',
        department: 'Departamento',
        byLine: 'Classificação por item',
        recurrence: 'Recorrência',
        type: 'Tipo',
        card: 'Cartão',
        tax: 'Imposto',
        competency: 'Competência',
      },
      lineCount_one: '{{count}} item',
      lineCount_other: '{{count}} itens',
      moreSplits: '+{{count}}: {{list}}',
      recurring: 'Recorrente',
      recurringEvery: 'Recorrente · {{frequency}}',
      installment: 'Parcela {{number}}',
      notRecurring: 'Não recorrente',
      frequency: {
        WEEKLY: 'semanal',
        MONTHLY: 'mensal',
        BIMONTHLY: 'bimestral',
        QUARTERLY: 'trimestral',
        SEMESTERLY: 'semestral',
        YEARLY: 'anual',
      },
      cardStatement: 'Fatura de cartão',
      taxSlip: 'Guia de imposto',
      cardProviders: {
        MANUAL: 'Manual',
        CLARA: 'Clara',
        CONTA_SIMPLES: 'Conta Simples',
        PLAID: 'Plaid',
        BREX: 'Brex',
      },
      notes: {
        cardStatement: 'Fatura de cartão: cada compra já tem a sua classificação.',
        taxFromSlot: 'Guia de imposto: a conta contábil vem do imposto, sem classificação.',
        unclassified: 'Esta conta ainda não tem classificação.',
      },
    },
    email: {
      kind: 'E-mail sem conta',
      received: 'Recebido em {{date}}',
      dismissConfirm: 'Confirmar dispensa',
      checkBill: 'Conferir conta existente',
      billedReason:
        'Esta nota já tem a conta {{number}}. Confira se ela está certa e depois dispense este e-mail.',
      billedReasonNoNumber:
        'Esta nota já tem uma conta. Confira se ela está certa e depois dispense este e-mail.',
      chooseCompany: 'Escolher empresa',
      chooseVendor: 'Escolher fornecedor',
      attachDocument: 'Anexar documento',
      showEmail: 'Ver e-mail',
      backToList: 'Voltar à lista',
      askSender: 'Pedir ao remetente',
      askSenderTitle: 'Pedir ao remetente',
      askSenderDescription:
        'O remetente recebe esta mensagem como resposta ao e-mail, mesmo que a resposta automática já tenha sido enviada. Quando ele responder, o e-mail é processado de novo.',
      askSenderTo: 'Para',
      askSenderMessage: 'Mensagem',
      askSenderSend: 'Enviar pedido',
      askSenderCancel: 'Cancelar',
      askSenderEmpty: 'Escreva a mensagem.',
      searchVendor: 'Buscar fornecedor por nome ou identificador fiscal',
      vendorsEmpty: 'Nenhum fornecedor encontrado.',
      vendorsFailed: 'Não foi possível buscar os fornecedores. Tente de novo.',
      vendorsSearching: 'Buscando fornecedores…',
      vendorForeign: 'Estrangeiro · {{country}}',
      uploading: 'Enviando {{name}}…',
      noBody: 'Este e-mail não tem texto.',
      bodyWithheld:
        'O texto deste e-mail não aparece: um anexo já tem conta em uma empresa que você não acessa.',
      noFiles: 'Sem anexos.',
      senderReply: 'Resposta do remetente',
      senderReplyFrom: '{{from}} · {{date}}',
      senderReplyEmpty: 'A resposta não tem texto.',
      files: 'Anexos',
      loading: 'Carregando o e-mail',
      loadError: 'Não foi possível carregar o e-mail.',
      bodyTruncated: 'O texto é longo e foi cortado aqui.',
      fileInvalid: 'Envie um PDF, PNG ou JPEG de até {{size}}.',
      askDraft: {
        greeting: 'Olá, {{name}},',
        greetingNoName: 'Olá,',
        document:
          'Recebemos o seu e-mail "{{subject}}", mas ele não traz a nota fiscal, o boleto nem o recibo. Responda a este e-mail com o documento anexado e nós lançamos a conta.',
        taxId:
          'Recebemos o seu e-mail "{{subject}}", mas não encontramos o identificador fiscal do fornecedor. Responda com o identificador fiscal (CNPJ ou CPF, se o fornecedor for brasileiro) e o país do fornecedor.',
        password:
          'Recebemos o seu e-mail "{{subject}}", mas o PDF tem senha. Responda com a senha ou com o documento sem senha.',
        company:
          'Recebemos o seu e-mail "{{subject}}", mas não sabemos para qual empresa ele é. Responda com o nome ou o CNPJ da empresa.',
        generic:
          'Recebemos o seu e-mail "{{subject}}", mas precisamos de mais informações para lançar a conta. Responda com os dados que faltam.',
        closing: 'Obrigado.',
      },
    },
    types: {
      billApproval: 'Aprovação de conta',
      reimbursementApproval: 'Aprovação de reembolso',
      purchaseRequestApproval: 'Aprovação de requisição de compra',
      budgetException: 'Exceção de orçamento',
      fleetProposal: 'Proposta do agente',
      ruleReview: 'Regra de conciliação',
      openFinanceConnection: 'Conexão bancária com problema',
    },
  },
  review: {
    title: 'Revisão por área',
    bank: 'Conciliação bancária',
    cards: 'Cartões corporativos',
    bills: 'Contas a pagar',
    billsUnit: 'em revisão',
    billsAmount: 'Valor total',
    transactionsUnit: 'transações',
    unavailable: 'Consulte a área para ver os itens.',
    billsAction: 'Abrir contas',
    bankAction: 'Abrir conciliação',
    cardsAction: 'Abrir cartões',
    pendingUnit: 'a conciliar',
    moneyIn: 'Entradas',
    moneyOut: 'Saídas',
  },
  cash: {
    title: 'Caixa',
    loading: 'Carregando projeção de caixa',
    balance: 'Saldo atual consolidado',
    accounts: 'contas bancárias',
    lowest: 'Menor saldo projetado:',
    viewDetails: 'Ver fluxo de caixa',
    unavailable: 'Ainda não há saldo bancário consolidado para mostrar.',
    noAccess: 'Você não tem acesso à projeção de caixa.',
    incomplete: 'A projeção contém valores sem conversão cambial. Confira os detalhes.',
    error: 'Não foi possível carregar o fluxo de caixa.',
    retry: 'Tentar novamente',
    staleConnections: 'Conexões que precisam de atenção',
    projectionPeriod: 'Projeção para as próximas 13 semanas',
    updatedOn: 'Saldo atualizado em {{date}}',
    unknownBank: 'Instituição não identificada',
    neverSynced: 'Ainda não sincronizada',
    staleSince: 'Última sincronização em {{date}}',
    chartToday: 'hoje',
    chartStart_one: 'há {{count}} semana',
    chartStart_other: 'há {{count}} semanas',
    changePeriod: 'nos últimos 30 dias',
    chartEnd_one: 'em {{count}} semana',
    chartEnd_other: 'em {{count}} semanas',
    lowestWeek: 'na semana de',
    nextSeven: 'Próximos 7 dias',
    moneyIn: 'entra',
    moneyOut: 'sai',
    reconnect: 'Reconectar',
    accountUpdatedOn: 'Saldo de {{date}}',
    noBalance: 'Sem saldo informado',
    accountsError: 'Não foi possível carregar as contas bancárias.',
    allAccounts_one: 'Ver a conta',
    allAccounts_other: 'Ver todas as {{count}} contas',
  },
  closingPreview: {
    pageTitle: 'Checklist de fechamento',
    context: 'Outubro 2026 · Alfa Participações · corte em 31/10',
    heading: 'Fechamento de outubro',
    summary:
      '<strong>{{count}} pendências precisam de você.</strong> {{waiting}} controles aguardam etapas anteriores; o resto está em dia.',
    updated: 'Atualizado hoje às 07:42',
    refresh: 'Atualizar agora',
    refreshing: 'Atualizando…',
    resolve: 'Resolver as {{count}} pendências',
    complete: 'Tudo resolvido',
    closed: '{{percent}}% fechado',
    progress: '{{complete}} de {{total}} obrigatórios em dia',
    entityLabel: 'Entidade',
    bookLabel: 'Livro',
    periodLabel: 'Período',
    liveContext: '{{entity}} · {{start}} – {{end}}',
    entities: { alfa: 'Alfa Participações', aurora: 'Aurora Participações' },
    periods: { october: 'Outubro 2026', september: 'Setembro 2026' },
    decisionTitle: 'Precisa de você',
    controlsTitle: 'Controles',
    activityTitle: 'Atividade',
    current: 'Em dia',
    waiting: 'aguardando etapa',
    consultative: 'Consultivo',
    pending_one: '{{count}} pendência',
    pending_other: '{{count}} pendências',
    needsReview: 'Requer análise',
    areaProgress: 'de {{total}} em dia',
    filterAll: 'Todos · {{count}}',
    filterPending: 'Com pendência · {{count}}',
    filterWaiting: 'Aguardando · {{count}}',
    filterConsultative: 'Consultivos · {{count}}',
    controlsCount: '{{shown}} de {{total}}',
    groupCount_one: '{{count}} controle',
    groupCount_other: '{{count}} controles',
    noControls: 'Nenhum controle atende a este filtro.',
    factsHeading: 'O que foi verificado',
    openDetails: 'Ver os itens',
    recheck: 'Reavaliar',
    runNow: {
      title: 'Agente de conciliação bancária',
      description:
        'Lê os movimentos bancários sem conciliação e procura a conta a pagar de cada um. Gera propostas de conciliação e de regras por fornecedor, que você aprova ou recusa em Pendências.',
      modeBadge: { shadow: 'Modo sombra', live: 'Modo ativo', off: 'Desligado' },
      pastRuns: 'Ver execuções anteriores',
      label: 'Rodar agora',
      runningLabel: 'Rodando…',
      off: 'O agente está desligado para esta empresa.',
      running: 'Uma execução está em andamento.',
      statusError: 'Não foi possível ler o estado do agente.',
      mode: {
        shadow: 'O agente só propõe. Ele não concilia nada sozinho.',
        live: 'O agente concilia o que é seguro e propõe o resto.',
        off: 'O agente está desligado para esta empresa.',
      },
      finished_zero: 'A execução terminou sem propostas abertas.',
      finished_one: 'A execução terminou com {{count}} proposta aberta.',
      finished_other: 'A execução terminou com {{count}} propostas abertas.',
      failed: 'A execução falhou.',
      refused: {
        FLEET_DAILY_RUN_LIMIT:
          'O limite de {{limit}} execuções por dia (UTC) deste agente foi atingido. Tente de novo amanhã.',
        FLEET_RUN_IN_PROGRESS: 'Uma execução deste agente já está em andamento.',
        FLEET_AGENT_OFF: 'O agente está desligado para esta empresa.',
        FLEET_RUN_NOT_QUEUED:
          'Não foi possível iniciar a execução agora. Tente novamente em instantes.',
      },
      openPending: 'Ver propostas em Pendências',
      openRun: 'Ver a execução',
    },
    emptyDecisionTitle: 'Nada pendente com você.',
    emptyDecisionDescription:
      'Os controles que aguardam etapas anteriores abrem sozinhos quando chegar a hora.',
    decisionPosition: '{{current}} de {{total}}',
    approveShortcut: 'A',
    clearArea: 'Limpar área',
    soon: 'Em breve',
    unavailable: 'Ainda não disponível',
    ownersTitle: 'Responsáveis',
    howCheckedTitle: 'Como é verificado',
    historyTitle: 'Histórico',
    notesTitle: 'Notas',
    historyEmpty: 'Nenhum histórico ainda.',
    notesEmpty: 'Nenhuma nota.',
    loading: 'Carregando o checklist de fechamento',
    error: 'Não foi possível carregar o checklist de fechamento.',
    assessed: 'avaliado hoje, 07:42',
    areas: {
      cash: 'Caixa e bancos',
      payables: 'Contas a pagar',
      receivables: 'Contas a receber',
      people: 'Pessoas',
      tax: 'Impostos',
      assets: 'Ativos',
      accounting: 'Contabilidade',
    },
    facts: {
      items: 'O que foi verificado',
      period: 'Vale para outubro',
      rule: 'Regra',
      yes: 'Sim',
    },
    controls: {
      genericDescription: 'Controle avaliado automaticamente para o período de outubro.',
      cx01: {
        label: 'Extratos importados até o corte',
        description: 'Todas as contas bancárias com extrato até a data de corte.',
        fact: '6 itens · todas as fontes ativas',
        rule: 'cx01.imports.v3',
      },
      cx02: {
        label: 'Conciliação bancária completa',
        description: 'Cada transação dos extratos casada com um lançamento.',
        fact: '214 itens · todas as fontes ativas',
        rule: 'cx02.reconciliation.v3',
      },
      cx03: {
        label: 'Saldo bancário × razão',
        description:
          'O saldo de cada conta no extrato é igual ao saldo da conta contábil na data de corte.',
        fact: '6 itens · todas as fontes ativas',
        rule: 'cx03.balance.v3',
      },
      ap01: {
        label: 'Contas recebidas lançadas',
        description: 'Toda conta recebida no período está lançada ou explicitamente adiada.',
        fact: '378 itens · todas as fontes ativas',
        rule: 'ap01.received-bills.v3',
      },
      ap03: {
        label: 'Cobertura de despesas incorridas',
        description:
          'Serviços e despesas incorridos no período, inclusive sem pedido ou nota fiscal.',
        soonLabel:
          'Para contar no fechamento, cadastre as fontes esperadas de serviços que não chegam por nota.',
      },
      ap05: {
        label: 'Estimativas em aberto',
        description: 'Provisões lançadas sem baixa e sem decisão de manter neste período.',
        fact: '12 itens · todas as fontes ativas',
        rule: 'ap05.accruals.v3',
      },
      tx01: {
        label: 'Retenções a recolher × razão',
        description:
          'IRRF, PIS, COFINS, CSLL, INSS e ISS retidos batendo com as contas de impostos a recolher.',
        fact: '6 itens · todas as fontes ativas',
        rule: 'tx01.withholdings.v3',
      },
      tx02: {
        label: 'Guias do período geradas',
        description: 'DARF, DAS e guias municipais geradas e lançadas.',
        dependency: 'Depende de TX01: as guias saem da apuração das retenções.',
      },
      pe02: {
        label: 'Provisões de férias e 13º',
        description: 'Provisões calculadas a partir da folha fechada.',
        dependency: 'Depende da folha de outubro estar fechada no módulo Pessoas.',
      },
      ar01: {
        label: 'Faturamento × contratos',
        description: 'Toda receita recorrente prevista em contrato foi faturada no período.',
        fact: '48 itens · todas as fontes ativas',
        rule: 'ar01.billing.v3',
      },
      cx04: {
        label: 'Aplicações × razão',
        description:
          'O saldo de cada aplicação financeira é comparado ao saldo da conta contábil na data de corte.',
      },
      ap02: {
        label: 'Aprovações concluídas',
        description: 'Toda conta do período passou pela aprovação exigida antes do lançamento.',
      },
      ap04: {
        label: 'Ocorrências recorrentes cobertas',
        description:
          'Cada ocorrência recorrente esperada no período é comparada a uma conta ou estimativa postada.',
      },
      ap06: {
        label: 'Baixa de estimativa e estorno devido',
        description:
          'A estimativa é baixada quando a conta definitiva chega, e o estorno é conferido para não duplicar a despesa.',
      },
      ap07: {
        label: 'Fornecedores × razão',
        description:
          'O saldo de cada fornecedor no auxiliar é comparado ao saldo da conta no razão.',
      },
      ap08: {
        label: 'Efeitos da liquidação de pagamentos',
        description:
          'Cada liquidação do período — pagamento, retenção, desconto, juros ou adiantamento — tem o lançamento correspondente.',
      },
      ar02: {
        label: 'Recebimentos conciliados',
        description:
          'Cada recebimento do período está conciliado com o título e com o lançamento contábil.',
      },
      pe01: {
        label: 'Folha lançada',
        description:
          'A folha do período está lançada no razão, com os totais de salários, encargos e descontos.',
      },
      at01: {
        label: 'Aquisições cadastradas como ativo',
        description:
          'Cada aquisição do período que atende à política está cadastrada como ativo, e não só como despesa.',
      },
      at02: {
        label: 'Depreciação e amortização lançadas',
        description:
          'A depreciação e a amortização do período estão calculadas e lançadas para os ativos em uso.',
      },
      at03: {
        label: 'Ativos × razão',
        description: 'O saldo de cada ativo no cadastro é comparado ao saldo da conta no razão.',
      },
      gl01: {
        label: 'Lançamentos manuais revisados',
        description: 'Cada lançamento manual do período foi revisado por alguém que não o criou.',
      },
      gl02: {
        label: 'Variação cambial lançada',
        description:
          'A variação cambial do período está calculada e lançada nas contas em moeda estrangeira.',
      },
      gl03: {
        label: 'Balancete sem transitórias com saldo',
        description: 'O balancete do período não tem saldo em contas transitórias.',
        dependency: 'Depende de CX02, AP05 e TX01.',
      },
    },
    decisions: {
      ap05: {
        kind: 'Estimativa sem baixa',
        title: 'Provisão de energia · setembro',
        context: 'Lançada em 30/09 · nenhuma baixa e nenhuma decisão de manter',
        reasoning:
          'A conta definitiva da Enel ({{amount}}) chegou em 08/10 e cobre o mesmo período. Sugiro baixar a provisão contra ela; a diferença de {{difference}} vai para a despesa de outubro.',
        secondary: 'Manter neste período',
        primary: 'Baixar contra a conta',
      },
      cx02: {
        kind: 'Conciliação',
        title: '4 transações do Inter sem par',
        context: 'Banco Inter ···1190 · entre 02/10 e 13/10',
        reasoning:
          'Três são tarifas e IOF ({{amount}}) que posso lançar agora. A quarta é um Pix recebido de {{pix}} sem fatura correspondente; esse fica com você.',
        secondary: 'Abrir conciliação',
        primary: 'Lançar as 3 tarifas',
      },
      tx01: {
        kind: 'Diferença com o razão',
        title: 'IRRF a recolher não bate',
        context: 'Conta 2.1.3.01 · razão {{ledger}} × controle {{control}}',
        reasoning:
          'A diferença vem de uma retenção alterada depois do lançamento e não relançada. Sugiro reprocessar o lançamento dessa conta.',
        secondary: 'Ver a conta',
        primary: 'Reprocessar o lançamento',
      },
    },
    activity: {
      current: {
        time: 'hoje 07:42',
        description:
          'Reavaliei os {{controls}} controles. 3 têm pendência e 3 aguardam etapas anteriores.',
      },
      bank: {
        time: 'hoje 07:40',
        description:
          'Conciliei {{entries}} lançamentos do Itaú. CX02 caiu de 42 para 4 pendências.',
      },
      payables: {
        time: '13/10 21:11',
        description: 'Will publicou a avaliação de contas a pagar.',
      },
      resolved: {
        time: 'agora',
        ap05: 'Baixei a provisão de energia contra a conta definitiva.',
        cx02: 'Lancei as tarifas pendentes do Banco Inter.',
        tx01: 'Reprocessei o lançamento de IRRF a recolher.',
      },
    },
  },
  agentReview: {
    decisionCount_one: '{{count}} decisão',
    decisionCount_other: '{{count}} decisões',
    position: '{{current}} de {{total}}',
    approveShortcut: 'A',
    rejectShortcut: 'R',
    agentName: 'Alquimista de conciliação bancária',
    error: 'Não foi possível carregar as propostas do alquimista.',
    emptyTitle: 'Nenhuma proposta do alquimista',
    emptyDescription:
      'Quando o alquimista propuser uma conciliação ou uma regra, ela aparece aqui.',
    proposalsCapped: 'Mostrando as {{shown}} propostas mais recentes de {{total}}.',
    proposal: {
      kind: 'Proposta do alquimista',
      approve: 'Aceitar',
      reject: 'Recusar',
    },
    pairing: {
      columns: {
        date: 'Data',
        issueDate: 'Emissão',
        dueDate: 'Vencimento',
        detail: 'Detalhe',
        origin: 'Origem',
        amount: 'Valor',
      },
      bankMovement: 'Movimento bancário',
      cardPurchase: 'Compra no cartão',
      bill: 'Conta a pagar',
      billNumber: 'Nota {{number}}',
      noBillNumber: 'Sem número',
      noDescription: 'Sem descrição',
      unknownVendor: 'Fornecedor sem nome',
      openBill: 'Abrir conta',
      paymentOf: 'Pagamento · {{status}}',
      paymentOn: 'Pago em {{date}}',
      paymentScheduledFor: 'Agendado para {{date}}',
      match: {
        title: 'Conciliar – {{vendor}}: {{amount}}',
      },
      evidence: {
        other: 'Proposta do alquimista',
        exact: {
          connector: 'Valor exato',
          reason: 'O valor do movimento é igual ao valor em aberto da conta.',
        },
        foreign_exact: {
          connector: 'Variação cambial',
          reason:
            'O recibo tem o mesmo valor em moeda estrangeira nos dois lados. A diferença em reais é variação cambial.',
        },
        document_penalty: {
          connector: 'Conta + encargos do boleto',
          reason: 'O pagamento cobre a conta e os encargos impressos no boleto.',
        },
        vendor_rule: {
          connector: 'Regra do fornecedor',
          reason: 'A diferença segue a regra aprovada para este fornecedor.',
        },
        paid_payment: {
          connector: 'Pagamento já registrado',
          reason:
            'A conta já tem um pagamento registrado com este valor. O movimento confirma esse pagamento.',
        },
        processing_payment: {
          connector: 'Pagamento em processamento',
          reason:
            'A conta tem um pagamento em processamento com este valor. O movimento confirma esse pagamento.',
        },
        rule_pending: {
          connector: 'Regra em análise',
          reason: 'A diferença segue uma regra do fornecedor que ainda espera sua aprovação.',
        },
      },
      adjustment: {
        IOF: 'IOF {{amount}}',
        JUROS: 'juros {{amount}}',
        MULTA: 'multa {{amount}}',
        other: '{{type}} {{amount}}',
      },
      duplicate: {
        title: 'Cancelar duplicada – {{vendor}}: {{amount}}',
        titleNoVendor: 'Cancelar duplicada: {{amount}}',
        subtitle: 'Nota {{number}} · emitida em {{date}}',
        connector: 'Mesma nota',
        keep: 'Manter',
        void: 'Cancelar',
        sameNumber: 'As duas contas têm a nota {{number}}.',
        renamed: 'A nota {{void}} é a mesma {{keep}}.',
        fastTrack:
          'A conta de baixo chegou por e-mail, e o fast track de cartão já pagou a de cima.',
        outcome: 'A conta marcada “Cancelar” será cancelada.',
        outcomeWithDocuments_one:
          'A conta marcada “Cancelar” será cancelada, e o documento dela passa para a outra.',
        outcomeWithDocuments_other:
          'A conta marcada “Cancelar” será cancelada, e os {{count}} documentos dela passam para a outra.',
      },
      movedLink: {
        title: 'Mover vínculo – {{vendor}}: {{amount}}',
        connector: 'Mover cobrança de {{amount}}',
        reason:
          'Outra conta do fornecedor tem exatamente o valor da cobrança. Mover o vínculo para ela?',
        fromEyebrow: 'Hoje conciliada com',
        toEyebrow: 'Passa a conciliar com',
        from: 'Sai',
        to: 'Entra',
      },
    },
    toast: {
      ruleAccepted:
        'Regra aprovada. As linhas que servem a uma só conta são conciliadas na próxima execução do alquimista.',
    },
    bookAs: {
      IOF: 'IOF',
      JUROS: 'juros',
      MULTA: 'multa',
    },
    rule: {
      kind: 'Regra proposta',
      reason_one:
        'O alquimista de conciliação bancária propôs uma regra que resolve {{count}} linha.',
      reason_other:
        'O alquimista de conciliação bancária propôs uma regra que resolve {{count}} linhas.',
      subtitle: 'Valor pago = valor da conta × {{factor}}. A diferença vai para {{bookAs}}.',
      subtitleNoGap: 'Valor pago = valor da conta. Nenhuma linha tem diferença.',
      splitAuto_one:
        '{{count}} linha concilia sozinha, se couber no limite de {{max}} por execução.',
      splitAuto_other:
        '{{count}} linhas conciliam sozinhas, se couberem no limite de {{max}} por execução.',
      splitChoose_one:
        '{{count}} tem outra conta que também serve e continua aqui para você escolher.',
      splitChoose_other:
        '{{count}} têm outra conta que também serve e continuam aqui para você escolher.',
      splitApprove_one: '{{count}} passa de um limite do agente e volta para você aprovar.',
      splitApprove_other: '{{count}} passam de um limite do agente e voltam para você aprovar.',
      splitShadow:
        'O agente está em modo sombra: nenhuma linha concilia sozinha. Todas continuam aqui como propostas.',
      viewLines_one: 'Ver a linha',
      viewLines_other: 'Ver as {{count}} linhas',
      approve: 'Aprovar a regra',
      reject: 'Recusar',
      rejectConfirm: {
        title: 'Recusar a regra de {{vendor}}?',
        description:
          'O alquimista não vai mais sugerir esta regra para {{vendor}}. Nenhuma das {{count}} linhas é conciliada. Você pode conciliá-las à mão na conciliação bancária.',
        confirm: 'Recusar a regra',
        cancel: 'Voltar',
      },
    },
    dialog: {
      title: 'Regra de {{vendor}}',
      summaryAuto_one: '{{count}} concilia sozinha',
      summaryAuto_other: '{{count}} conciliam sozinhas',
      summaryChoose_one: '{{count}} você escolhe',
      summaryChoose_other: '{{count}} você escolhe',
      summaryApprove_one: '{{count}} você aprova',
      summaryApprove_other: '{{count}} você aprova',
      summaryAllAuto_one: 'A linha concilia sozinha',
      summaryAllAuto_other: 'As {{count}} linhas conciliam sozinhas',
      runLimit:
        'O agente concilia sozinho até {{max}} linhas por execução, somando todas as regras e conciliações. As linhas a mais voltam como proposta.',
      columns: {
        charge: 'Valor pago',
        bill: 'Conta',
        gap: 'Diferença ({{bookAs}})',
        result: 'Resultado',
      },
      outcome: {
        auto: 'Concilia sozinha',
        approve: 'Você aprova',
        choose: 'Você escolhe',
      },
      capReason: {
        amount_cap: 'Passa do limite por cobrança: volta como proposta',
        amount_unknown: 'Sem cotação do dia para conferir o limite: volta como proposta',
        count_cap: 'Passa do limite de conciliações por execução: volta como proposta',
      },
      otherBill: 'Outra conta também serve: {{amount}} ({{date}})',
      otherBillNoDate: 'Outra conta também serve: {{amount}}',
      close: 'Fechar',
    },
  },
  alchemistsCard: {
    title: 'Seus alquimistas',
    description: 'Os agentes que trabalham para você e a última execução de cada um.',
    neverRan: 'Ainda não rodou.',
    running: 'Rodando agora',
    loading: 'Carregando alquimistas…',
    error: 'Não foi possível carregar os alquimistas.',
    emptyTitle: 'Nenhum alquimista ligado',
    emptyDescription: 'Quando um agente for ligado para esta empresa, ele aparece aqui.',
    openRuns: 'Ver execuções do alquimista {{name}}',
    openLastRun: 'Ver a última execução do alquimista {{name}}',
    openProposals_one: '{{count}} proposta para você',
    openProposals_other: '{{count}} propostas para você',
    unknownAgent: 'Alquimista',
    agents: {
      reconciliation: {
        name: 'Conciliação',
        role: 'Concilia o extrato com os lançamentos.',
      },
    },
  },
  agentRuns: {
    title: 'Execuções do agente',
    subtitle: 'O que o agente de conciliação leu e decidiu, execução a execução.',
    modeSwitch: {
      label: 'Modo ativo',
      loading: 'Carregando o modo do agente',
      error: 'Não foi possível ler o modo do agente.',
      off: 'O agente está desligado para esta empresa.',
      noPermission: 'Só quem pode conciliar muda o modo do agente.',
      noPermissionLive: 'Só quem pode conciliar e aprovar regras de fornecedor liga o modo ativo.',
      default: 'Modo sombra: o padrão. Ninguém mudou o modo ainda.',
      changedBy: 'Alterado por {{name}} em {{date}}',
      confirmLive: {
        title: 'Ligar o modo ativo?',
        description:
          'O agente vai conciliar sozinho os pares que forem seguros. O resto continua como proposta para você.',
        amountCap: 'Até {{amount}} por conciliação.',
        countCap_one: 'No máximo {{count}} conciliação por execução.',
        countCap_other: 'No máximo {{count}} conciliações por execução.',
        closedPeriods: 'Nunca em um período fechado.',
        nextRun: 'Vale a partir da próxima execução. Uma execução em andamento não muda.',
        audit: 'A mudança fica registrada com o seu nome.',
        confirm: 'Ligar o modo ativo',
      },
      confirmShadow: {
        title: 'Voltar para o modo sombra?',
        description:
          'O agente vai só propor conciliações. Ele não concilia mais nada sozinho. Vale a partir da próxima execução, e a mudança fica registrada com o seu nome.',
        confirm: 'Voltar para o modo sombra',
      },
      refused: {
        FLEET_AGENT_OFF: 'O agente está desligado para esta empresa.',
        FLEET_PERMISSION_REQUIRED: 'Você não tem permissão para mudar o modo do agente.',
      },
    },
    story: {
      trigger: {
        MANUAL: 'Execução manual',
        SCHEDULED: 'Execução agendada',
      },
      dateLabel: '{{trigger}} · {{date}}',
      headline: {
        proposed_one: 'O agente analisou {{candidates}} transações e propôs {{count}} conciliação.',
        proposed_other:
          'O agente analisou {{candidates}} transações e propôs {{count}} conciliações.',
        actedAndProposed:
          'O agente analisou {{candidates}} transações, conciliou {{acted}} e propôs {{proposed}}.',
        nothing: 'O agente analisou {{candidates}} transações e não achou nenhum par seguro.',
        running: 'O agente está analisando as transações.',
        failed: 'A execução parou antes de terminar.',
        skipped: 'A execução não começou.',
        stoppedBudget: 'O agente parou no limite de trabalho desta execução.',
      },
      summary: {
        rejected_one: '{{count}} par foi recusado na verificação.',
        rejected_other: '{{count}} pares foram recusados na verificação.',
        noVerdict_one: 'Em {{count}} transação o modelo não deu veredito.',
        noVerdict_other: 'Em {{count}} transações o modelo não deu veredito.',
        shadow: 'Em modo sombra, nada foi conciliado sozinho: você decide cada proposta.',
        live: 'Em modo ativo, o agente conciliou só o que era seguro.',
        duration: 'Durou {{duration}}.',
        running: 'Esta página se atualiza sozinha até a execução terminar.',
        failedDecided_one: 'O agente chegou a decidir {{count}} transação antes de parar.',
        failedDecided_other: 'O agente chegou a decidir {{count}} transações antes de parar.',
      },
      stopReason: {
        abandoned: 'A execução ficou parada sem terminar e foi encerrada.',
        notQueued: 'A execução não chegou a começar. Execute de novo em instantes.',
        workerLost: 'O servidor reiniciou no meio da execução.',
        other: 'A execução parou por um erro interno.',
      },
      // A no-break space keeps each number on the line of its unit.
      duration: {
        seconds: '{{seconds}}\u00a0s',
        minutes: '{{minutes}}\u00a0min\u00a0{{seconds}}\u00a0s',
        hours: '{{hours}}\u00a0h\u00a0{{minutes}}\u00a0min',
      },
      gauge: {
        title: 'Candidatos analisados nesta execução',
        judged: '{{judged}} de {{candidates}} analisadas',
      },
      flow: {
        title: 'O caminho desta execução',
        sourceHeading: 'O que o agente leu',
        stageHeading: 'O que ele decidiu',
        outputHeading: 'Virou ouro',
        outputDetailLive: 'Conciliadas pelo agente',
        outputDetailShadow: 'Modo sombra: nada é conciliado sozinho',
        pending: 'esperam você em Pendências',
        nonePending: 'Nada esperando você',
        unavailable: 'Dado indisponível',
        sources: {
          candidates: 'Candidatos',
          byType: { BANK_TX: 'Transações bancárias', CARD_ITEM: 'Transações de cartão' },
          other: 'Outros itens',
          neverAgain: 'Já recusados antes',
        },
        stages: {
          proposed: 'Propostas',
          rejected: 'Recusadas',
          noVerdict: 'Sem veredito',
          declinedUnchanged: 'Recusadas antes, nada mudou',
          actFailed: 'O sistema recusou',
        },
      },
      side: {
        duration: 'Duração',
      },
      agents: {
        reconciliation: 'Agente de conciliação bancária',
      },
      decisionsSubtitle: 'Cada transação que o agente olhou, e por quê.',
      dateLabelMode: '{{trigger}} · {{date}} · {{mode}}',
      openPending: 'Abrir Pendências',
      reviewRule: 'Revisar regra',
      columns: { transaction: 'Transação', counterpart: 'Conta a pagar' },
      origin: { BANK_TX: 'Banco', CARD_ITEM: 'Cartão' },
      counterpart: {
        due: '{{amount}} · vence {{date}}',
        issued: '{{amount}} · emitida {{date}}',
        draftRule: 'Regra nova para este fornecedor',
      },
      runs: {
        title: 'Execuções recentes',
        all: 'Ver todas as execuções',
        counts_one: '{{count}} proposta · {{open}} abertas',
        counts_other: '{{count}} propostas · {{open}} abertas',
        none: 'Nenhuma proposta',
      },
    },
    columns: {
      startedAt: 'Início',
      status: 'Situação',
      acted: 'Conciliadas',
      proposed: 'Propostas',
    },
    trigger: {
      SCHEDULED: 'Agendada',
      MANUAL: 'Manual',
    },
    status: {
      RUNNING: 'Em andamento',
      SUCCEEDED: 'Concluída',
      STOPPED_BUDGET: 'Parou no orçamento',
      FAILED: 'Falhou',
      SKIPPED: 'Não rodou: limite diário',
    },
    mode: {
      off: 'Desligado',
      shadow: 'Modo sombra',
      live: 'Modo ativo',
    },
    openProposals_one: '{{count}} aberta',
    openProposals_other: '{{count}} abertas',
    emptyTitle: 'Nenhuma execução ainda',
    emptyDescription: 'O agente roda todo dia às 05:00 UTC, ou na hora em "Rodar agora".',
    detail: {
      title: 'Execução do agente',
      loadError: 'Não foi possível carregar a execução.',
      skippedDailyLimit:
        'A execução agendada não começou: o limite de 5 execuções por dia (UTC) já tinha sido usado.',
    },
    reasons: {
      shadow_mode: 'Modo sombra: só propõe',
      count_cap: 'Limite de conciliações por execução atingido',
      amount_cap: 'Acima do valor máximo por conciliação',
      exact_amount: 'Valor exato',
      document_penalty: 'Juros e multa impressos no documento',
      vendor_rule: 'Regra do fornecedor',
      draft_vendor_rule: 'Regra do fornecedor em rascunho',
      vendor_rule_pending: 'Padrão visto, regra ainda não aprovada',
      foreign_amount_matches: 'Mesmo valor em moeda estrangeira nos dois lados',
      foreign_gap_too_large: 'Diferença cambial grande demais',
      same_e2e: 'Mesmo identificador Pix',
      paid_payment_date: 'Pagamento pago na mesma data',
      payment_still_processing: 'Pagamento ainda em processamento',
      payment_not_settled: 'Pagamento não liquidado',
      payment_amount_differs: 'Valor do pagamento diferente',
      payment_date_too_far: 'Data do pagamento distante',
      unique_fitting_bill_in_window: 'Única conta que cabe no período',
      judge_declined: 'O modelo não reconheceu o par',
      unexplained_gap: 'Diferença sem explicação',
      partial_payment: 'Pagamento parcial',
      currency_mismatch: 'Moedas diferentes',
      period_closed: 'Período fechado',
      BANK_STATEMENT_CLOSED: 'Extrato do mês fechado',
      ACCOUNTING_PERIOD_CLOSED: 'Período contábil fechado',
      movement_no_longer_open: 'O movimento já não está em aberto',
      document_no_longer_open: 'A conta já não está em aberto',
      vendor_changed: 'O fornecedor mudou',
      data_changed: 'Os dados mudaram',
      rejected_by_person: 'Rejeitada por uma pessoa',
      rule_needs_review: 'A regra precisa de revisão',
      rule_already_recorded: 'A regra já existe',
      gap_booking_unsupported_on_ap_settlement: 'Lançamento da diferença não suportado',
      bill_not_approved_gl_deferred: 'Conta não aprovada: contabilização adiada',
      correction_proposal_only: 'Correção: sempre uma proposta',
      candidate_error: 'Erro ao analisar o candidato',
      kept_bill_gone: 'A conta mantida não existe mais',
      bill_already_void: 'A conta já foi anulada',
      bill_no_longer_voidable: 'A conta não pode mais ser anulada',
      bills_no_longer_the_same_invoice: 'As contas já não são a mesma nota',
      link_no_longer_current: 'O vínculo já não está vigente',
      link_changed: 'O vínculo mudou',
      linked_bill_gone: 'A conta vinculada não existe mais',
      target_bill_gone: 'A conta de destino não existe mais',
      linked_bill_matches_the_charge: 'A conta vinculada já corresponde à cobrança',
      target_bill_no_longer_fits: 'A conta de destino já não se encaixa',
      minedManual_one: 'Visto em {{count}} conciliação manual',
      minedManual_other: 'Visto em {{count}} conciliações manuais',
      minedOpen_one: 'Visto em {{count}} par em aberto',
      minedOpen_other: 'Visto em {{count}} pares em aberto',
    },
    glDeferred: {
      BILL_NOT_APPROVED: 'Contabilização adiada: a conta ainda não foi aprovada',
      other: 'Contabilização adiada',
    },
    subject: {
      kind: {
        match: 'Movimento e conta',
        draft_rule: 'Regra de conciliação',
        duplicate_fast_track: 'Conta duplicada (fast-track)',
        twin_bills: 'Contas gêmeas',
        moved_link: 'Vínculo na conta errada',
      },
    },
    decisions: {
      title: 'Decisões',
      emptyTitle: 'Nenhuma decisão',
      emptyDescription: 'Esta execução não chegou a decidir nenhum candidato.',
      shown: 'Mostrando {{shown}} de {{total}} decisões',
      loadMore: 'Carregar mais',
      columns: {
        outcome: 'Resultado',
        gl: 'Contabilização',
      },
      outcome: {
        ACTED: 'Conciliada pelo agente',
        PROPOSED: 'Virou proposta',
        REJECTED: 'Recusada',
        ACT_FAILED: 'O sistema recusou',
        ACCEPTED: 'Aceita por uma pessoa',
      },
    },
  },
} as const;

export const labEn = {
  title: 'Laboratory',
  entity: {
    label: 'Entity',
    all: 'All entities',
  },
  greeting: {
    morning: 'Good morning, {{name}}',
    afternoon: 'Good afternoon, {{name}}',
    evening: 'Good evening, {{name}}',
    morningGeneric: 'Good morning',
    afternoonGeneric: 'Good afternoon',
    eveningGeneric: 'Good evening',
  },
  closing: {
    unavailable: 'Closing indicator unavailable',
    title: 'Items posted, classified, and reconciled this month',
  },
  summary: {
    solved_one: 'You resolved <strong>{{count}}</strong> item in {{month}}.',
    solved_other: 'You resolved <strong>{{count}}</strong> items in {{month}}.',
    remaining_one: '<strong>{{count}}</strong> left.',
    remaining_other: '<strong>{{count}}</strong> left.',
    pending_one: '<strong>{{count}}</strong> item needs your attention.',
    pending_other: '<strong>{{count}}</strong> items need your attention.',
    none: 'Nothing pending.',
  },
  score: {
    loading: 'Loading the monthly score',
    title: 'Items resolved this month',
    label: '{{solved}} of {{total}}',
    period: 'items resolved in {{month}}',
    none: 'Nothing pending',
    unavailable: 'Score unavailable',
  },
  flow: {
    title: 'This month',
    loading: 'Loading the flow',
    sourceHeading: 'What arrived',
    stageHeading: 'In progress',
    outputHeading: 'Turned to gold',
    outputDetail: 'Posted and reconciled',
    outputAmount: '{{amount}} reconciled in statements and cards',
    pending: 'need your attention',
    nonePending: 'Nothing waiting on you',
    unavailable: 'Data unavailable',
    error: 'Could not load the flow.',
    sources: {
      bank: 'Bank statements',
      cards: 'Corporate cards',
      email: 'Email',
      invoices: 'Tax documents',
      dda: 'DDA bank slips',
    },
    stages: {
      reading: 'Reading',
      classifying: 'Classifying',
      reconciling: 'Reconciling',
      ignored: 'Set aside',
    },
    details: {
      descriptions: {
        reading: 'Arrived, but is not a bill yet.',
        classifying: 'Became a bill, but the bill is not approved yet.',
        reconciling: 'A statement or card line with no match yet.',
        ignored: 'Ignored, rejected, cancelled or voided. Nothing to do.',
      },
      readingEmail: 'Alchemy is still reading these e-mails.',
      classifyingEmail: 'Includes e-mails waiting for the sender to answer.',
      links: {
        receivedNfs: 'Open received tax documents',
        ddaInbox: 'Open the DDA inbox',
        drafts: 'Open draft bills',
        forApproval: 'Open bills in approval',
        pendingLines: 'Open pending lines',
        suggestions: 'Open reconciliation suggestions',
      },
    },
  },
  decisions: {
    title: 'Needs you',
    loading: 'Loading your pending items',
    allEntities: 'Shows decisions for all entities.',
    emptyTitle: 'All caught up',
    emptyDescription: 'Nothing is waiting on you right now.',
    error: 'Could not load your pending items.',
    count_one: '{{count}} decision',
    count_other: '{{count}} decisions',
    openList_one: 'See the decision as a list',
    openList_other: 'See the {{count}} decisions as a list',
    listDescription: 'Everything waiting on your decision, with each item’s quick actions.',
    listDescriptionWithAgent:
      'Everything waiting on your decision except the agent’s proposals, which stay on the cards.',
    more: 'See all in Pending items',
    moreEmails_one: 'Load 1 more e-mail',
    moreEmails_other: 'Load {{count}} more e-mails',
    moreEmailsFailed: 'Could not load more e-mails. Try again.',
    position: '{{current}} of {{total}}',
    openPendingList: 'See the {{total}} pending items as a list, with bulk actions',
    pendingListTitle: 'Pending items',
    pendingListDescription: 'Approve or reject several pending items at once.',
    previous: 'Previous item',
    next: 'Next item',
    approve: 'Approve',
    approveShortcut: 'A',
    open: 'Open',
    reviewInPendencias: 'Decide in Pending items',
    dueOn: 'Due {{date}}',
    genericError: 'Could not finish. Try again.',
    bill: {
      untitled: 'Bill',
      number: 'Invoice {{number}}',
      alerts_one: '{{count}} alert on this bill',
      alerts_other: '{{count}} alerts on this bill',
      hasWarnings: 'This bill has warnings to check before approving. Open the bill to decide.',
      open: 'Open bill',
      ask: 'Needs your approval',
      facts: {
        glAccount: 'GL account',
        managerialAccount: 'Managerial account',
        costCenter: 'Cost center',
        department: 'Department',
        byLine: 'Classified by line',
        recurrence: 'Recurrence',
        type: 'Type',
        card: 'Card',
        tax: 'Tax',
        competency: 'Accrual month',
      },
      lineCount_one: '{{count}} line',
      lineCount_other: '{{count}} lines',
      moreSplits: '+{{count}}: {{list}}',
      recurring: 'Recurring',
      recurringEvery: 'Recurring · {{frequency}}',
      installment: 'Installment {{number}}',
      notRecurring: 'One-off',
      frequency: {
        WEEKLY: 'weekly',
        MONTHLY: 'monthly',
        BIMONTHLY: 'every two months',
        QUARTERLY: 'quarterly',
        SEMESTERLY: 'every six months',
        YEARLY: 'yearly',
      },
      cardStatement: 'Card statement',
      taxSlip: 'Tax slip',
      cardProviders: {
        MANUAL: 'Manual',
        CLARA: 'Clara',
        CONTA_SIMPLES: 'Conta Simples',
        PLAID: 'Plaid',
        BREX: 'Brex',
      },
      notes: {
        cardStatement: 'Card statement: each purchase already has its own classification.',
        taxFromSlot: 'Tax slip: the GL account comes from the tax, with no classification.',
        unclassified: 'This bill has no classification yet.',
      },
    },
    email: {
      kind: 'E-mail without a bill',
      received: 'Received on {{date}}',
      dismissConfirm: 'Confirm dismissal',
      checkBill: 'Check the existing bill',
      billedReason:
        'This invoice already has bill {{number}}. Check that it is right, then dismiss this e-mail.',
      billedReasonNoNumber:
        'This invoice already has a bill. Check that it is right, then dismiss this e-mail.',
      chooseCompany: 'Choose company',
      chooseVendor: 'Choose vendor',
      attachDocument: 'Attach document',
      showEmail: 'View e-mail',
      backToList: 'Back to the list',
      askSender: 'Ask the sender',
      askSenderTitle: 'Ask the sender',
      askSenderDescription:
        'The sender gets this message as a reply to the e-mail, even if the automatic reply was already sent. When they answer, the e-mail is processed again.',
      askSenderTo: 'To',
      askSenderMessage: 'Message',
      askSenderSend: 'Send request',
      askSenderCancel: 'Cancel',
      askSenderEmpty: 'Write the message.',
      searchVendor: 'Search vendor by name or tax ID',
      vendorsEmpty: 'No vendor found.',
      vendorsFailed: 'Could not search the vendors. Try again.',
      vendorsSearching: 'Searching vendors…',
      vendorForeign: 'Foreign · {{country}}',
      uploading: 'Uploading {{name}}…',
      noBody: 'This e-mail has no text.',
      bodyWithheld:
        'The text of this e-mail is hidden: a file already has a bill in a company you cannot access.',
      noFiles: 'No attachments.',
      senderReply: 'Sender reply',
      senderReplyFrom: '{{from}} · {{date}}',
      senderReplyEmpty: 'The reply has no text.',
      files: 'Attachments',
      loading: 'Loading the e-mail',
      loadError: 'The e-mail could not be loaded.',
      bodyTruncated: 'The text is long and was cut here.',
      fileInvalid: 'Send a PDF, PNG or JPEG of at most {{size}}.',
      askDraft: {
        greeting: 'Hi {{name}},',
        greetingNoName: 'Hi,',
        document:
          'We received your e-mail "{{subject}}", but it has no invoice, payment slip or receipt. Reply to this e-mail with the document attached and we will record the bill.',
        taxId:
          'We received your e-mail "{{subject}}", but we did not find the vendor tax ID. Reply with the tax ID (CNPJ or CPF if the vendor is Brazilian) and the vendor\'s country.',
        password:
          'We received your e-mail "{{subject}}", but the PDF has a password. Reply with the password or with the document without a password.',
        company:
          'We received your e-mail "{{subject}}", but we do not know which company it is for. Reply with the name or the tax ID of the company.',
        generic:
          'We received your e-mail "{{subject}}", but we need more information to record the bill. Reply with the missing data.',
        closing: 'Thank you.',
      },
    },
    types: {
      billApproval: 'Bill approval',
      reimbursementApproval: 'Reimbursement approval',
      purchaseRequestApproval: 'Purchase request approval',
      budgetException: 'Budget exception',
      fleetProposal: 'Agent proposal',
      ruleReview: 'Reconciliation rule',
      openFinanceConnection: 'Bank connection issue',
    },
  },
  review: {
    title: 'Review by area',
    bank: 'Bank reconciliation',
    cards: 'Corporate cards',
    bills: 'Accounts payable',
    billsUnit: 'to review',
    billsAmount: 'Total amount',
    transactionsUnit: 'transactions',
    unavailable: 'Open the area to see its items.',
    billsAction: 'Open bills',
    bankAction: 'Open reconciliation',
    cardsAction: 'Open cards',
    pendingUnit: 'to reconcile',
    moneyIn: 'Money in',
    moneyOut: 'Money out',
  },
  cash: {
    title: 'Cash',
    loading: 'Loading cash-flow projection',
    balance: 'Current consolidated balance',
    accounts: 'bank accounts',
    lowest: 'Lowest projected balance:',
    viewDetails: 'View cash flow',
    unavailable: 'No consolidated bank balance is available yet.',
    noAccess: 'You do not have access to the cash-flow projection.',
    incomplete:
      'The projection contains amounts without foreign exchange conversion. Review the details.',
    error: 'Could not load cash flow.',
    retry: 'Try again',
    staleConnections: 'Connections needing attention',
    projectionPeriod: 'Projection for the next 13 weeks',
    updatedOn: 'Balance updated on {{date}}',
    unknownBank: 'Unknown institution',
    neverSynced: 'Not synchronized yet',
    staleSince: 'Last synchronized on {{date}}',
    chartToday: 'today',
    chartStart_one: '{{count}} week ago',
    chartStart_other: '{{count}} weeks ago',
    changePeriod: 'in the last 30 days',
    chartEnd_one: 'in {{count}} week',
    chartEnd_other: 'in {{count}} weeks',
    lowestWeek: 'in the week of',
    nextSeven: 'Next 7 days',
    moneyIn: 'in',
    moneyOut: 'out',
    reconnect: 'Reconnect',
    accountUpdatedOn: 'Balance as of {{date}}',
    noBalance: 'No balance reported',
    accountsError: 'The bank accounts could not be loaded.',
    allAccounts_one: 'See the account',
    allAccounts_other: 'See all {{count}} accounts',
  },
  closingPreview: {
    pageTitle: 'Closing checklist',
    context: 'October 2026 · Alfa Participações · cut-off on 31/10',
    heading: 'October close',
    summary:
      '<strong>{{count}} pending items need you.</strong> {{waiting}} controls are waiting on previous steps; the rest is up to date.',
    updated: 'Updated today at 07:42',
    refresh: 'Refresh now',
    refreshing: 'Refreshing…',
    resolve: 'Resolve the {{count}} pending items',
    complete: 'All resolved',
    closed: '{{percent}}% closed',
    progress: '{{complete}} of {{total}} required controls are up to date',
    entityLabel: 'Entity',
    bookLabel: 'Book',
    periodLabel: 'Period',
    liveContext: '{{entity}} · {{start}} – {{end}}',
    entities: { alfa: 'Alfa Participações', aurora: 'Aurora Participações' },
    periods: { october: 'October 2026', september: 'September 2026' },
    decisionTitle: 'Needs you',
    controlsTitle: 'Controls',
    activityTitle: 'Activity',
    current: 'Up to date',
    waiting: 'waiting on a step',
    consultative: 'Consultative',
    pending_one: '{{count}} pending item',
    pending_other: '{{count}} pending items',
    needsReview: 'Needs a look',
    areaProgress: 'of {{total}} up to date',
    filterAll: 'All · {{count}}',
    filterPending: 'Pending · {{count}}',
    filterWaiting: 'Waiting · {{count}}',
    filterConsultative: 'Consultative · {{count}}',
    controlsCount: '{{shown}} of {{total}}',
    groupCount_one: '{{count}} control',
    groupCount_other: '{{count}} controls',
    noControls: 'No control matches this filter.',
    factsHeading: 'What was checked',
    openDetails: 'View items',
    recheck: 'Recheck',
    runNow: {
      title: 'Bank reconciliation agent',
      description:
        'Reads the bank movements with no reconciliation and looks for the bill of each one. Produces reconciliation proposals and per-vendor rules, which you approve or reject in Pending.',
      modeBadge: { shadow: 'Shadow mode', live: 'Live mode', off: 'Off' },
      pastRuns: 'See past runs',
      label: 'Run now',
      runningLabel: 'Running…',
      off: 'The agent is off for this company.',
      running: 'A run is in progress.',
      statusError: 'Could not read the agent status.',
      mode: {
        shadow: 'The agent only proposes. It settles nothing on its own.',
        live: 'The agent settles what is safe and proposes the rest.',
        off: 'The agent is off for this company.',
      },
      finished_zero: 'The run finished with no open proposals.',
      finished_one: 'The run finished with {{count}} open proposal.',
      finished_other: 'The run finished with {{count}} open proposals.',
      failed: 'The run failed.',
      refused: {
        FLEET_DAILY_RUN_LIMIT:
          'This agent has reached its limit of {{limit}} runs per day (UTC). Try again tomorrow.',
        FLEET_RUN_IN_PROGRESS: 'A run of this agent is already in progress.',
        FLEET_AGENT_OFF: 'The agent is off for this company.',
        FLEET_RUN_NOT_QUEUED: 'The run could not start right now. Try again in a moment.',
      },
      openPending: 'See the proposals in Pending',
      openRun: 'See the run',
    },
    emptyDecisionTitle: 'Nothing is pending with you.',
    emptyDecisionDescription:
      'Controls waiting on earlier steps open on their own when the time comes.',
    decisionPosition: '{{current}} of {{total}}',
    approveShortcut: 'A',
    clearArea: 'Clear area',
    soon: 'Coming soon',
    unavailable: 'Not available yet',
    ownersTitle: 'Assignees',
    howCheckedTitle: 'How it is checked',
    historyTitle: 'History',
    notesTitle: 'Notes',
    historyEmpty: 'No history yet.',
    notesEmpty: 'No notes.',
    loading: 'Loading closing checklist',
    error: 'Could not load the closing checklist.',
    assessed: 'assessed today, 07:42',
    areas: {
      cash: 'Cash and banks',
      payables: 'Accounts payable',
      receivables: 'Accounts receivable',
      people: 'People',
      tax: 'Taxes',
      assets: 'Assets',
      accounting: 'Accounting',
    },
    facts: { items: 'What was checked', period: 'Applies to October', rule: 'Rule', yes: 'Yes' },
    controls: {
      genericDescription: 'Control automatically assessed for the October period.',
      cx01: {
        label: 'Statements imported through cut-off',
        description: 'All bank accounts have a statement through the cut-off date.',
        fact: '6 items · all sources active',
        rule: 'cx01.imports.v3',
      },
      cx02: {
        label: 'Complete bank reconciliation',
        description: 'Every statement transaction is matched with an entry.',
        fact: '214 items · all sources active',
        rule: 'cx02.reconciliation.v3',
      },
      cx03: {
        label: 'Bank balance × ledger',
        description:
          'Each bank statement balance equals the general ledger account balance on the cut-off date.',
        fact: '6 items · all sources active',
        rule: 'cx03.balance.v3',
      },
      ap01: {
        label: 'Received bills posted',
        description: 'Every bill received during the period is posted or explicitly deferred.',
        fact: '378 items · all sources active',
        rule: 'ap01.received-bills.v3',
      },
      ap03: {
        label: 'Incurred expense coverage',
        description:
          'Services and expenses incurred in the period, including those without a purchase order or tax document.',
        soonLabel:
          'To count toward the close, register expected sources for services that do not arrive through a tax document.',
      },
      ap05: {
        label: 'Open estimates',
        description:
          'Accruals posted without settlement and without a decision to keep them in this period.',
        fact: '12 items · all sources active',
        rule: 'ap05.accruals.v3',
      },
      tx01: {
        label: 'Withholdings payable × ledger',
        description: 'Withheld taxes match the taxes payable accounts.',
        fact: '6 items · all sources active',
        rule: 'tx01.withholdings.v3',
      },
      tx02: {
        label: 'Period guides generated',
        description: 'Tax payment guides for the period were generated and posted.',
        dependency: 'Depends on TX01: guides follow the withholding assessment.',
      },
      pe02: {
        label: 'Vacation and 13th-month accruals',
        description: 'Accruals calculated from the closed payroll.',
        dependency: 'Depends on the October payroll being closed in People.',
      },
      ar01: {
        label: 'Billing × contracts',
        description: 'Every recurring revenue expected in a contract was billed in the period.',
        fact: '48 items · all sources active',
        rule: 'ar01.billing.v3',
      },
      cx04: {
        label: 'Investments × ledger',
        description:
          'Each investment balance is compared with the ledger account balance at the cutoff date.',
      },
      ap02: {
        label: 'Approvals completed',
        description: 'Every bill in the period went through the required approval before posting.',
      },
      ap04: {
        label: 'Recurring events covered',
        description:
          'Each recurring occurrence expected in the period is compared with a posted bill or estimate.',
      },
      ap06: {
        label: 'Estimate settlement and required reversal',
        description:
          'The estimate is settled when the final bill arrives, and the reversal is checked so the expense is not recorded twice.',
      },
      ap07: {
        label: 'Vendors × ledger',
        description: 'Each vendor subledger balance is compared with the ledger account balance.',
      },
      ap08: {
        label: 'Payment settlement effects',
        description:
          'Each settlement in the period — payment, withholding, discount, interest, or advance — has its journal entry.',
      },
      ar02: {
        label: 'Receipts reconciled',
        description:
          'Each receipt in the period is reconciled to the invoice and to the journal entry.',
      },
      pe01: {
        label: 'Payroll posted',
        description:
          'The period payroll is posted to the ledger, with totals for salaries, charges, and deductions.',
      },
      at01: {
        label: 'Acquisitions registered as assets',
        description:
          'Each acquisition in the period that meets the policy is registered as an asset, not only as an expense.',
      },
      at02: {
        label: 'Depreciation and amortization posted',
        description:
          'Depreciation and amortization for the period are calculated and posted for assets in use.',
      },
      at03: {
        label: 'Assets × ledger',
        description: 'Each asset register balance is compared with the ledger account balance.',
      },
      gl01: {
        label: 'Manual entries reviewed',
        description:
          'Each manual journal entry in the period was reviewed by someone who did not create it.',
      },
      gl02: {
        label: 'Foreign-exchange variation posted',
        description:
          'The period foreign-exchange variation is calculated and posted on foreign-currency accounts.',
      },
      gl03: {
        label: 'Trial balance without transitional balances',
        description: 'The period trial balance has no balance on transitional accounts.',
        dependency: 'Depends on CX02, AP05, and TX01.',
      },
    },
    decisions: {
      ap05: {
        kind: 'Estimate without settlement',
        title: 'Energy accrual · September',
        context: 'Posted on 30/09 · no settlement and no decision to keep it',
        reasoning:
          'The final Enel bill ({{amount}}) arrived on 08/10 and covers the same period. I suggest settling the accrual against it; the {{difference}} difference goes to October expense.',
        secondary: 'Keep in this period',
        primary: 'Settle against the bill',
      },
      cx02: {
        kind: 'Reconciliation',
        title: '4 unmatched Inter transactions',
        context: 'Banco Inter ···1190 · between 02/10 and 13/10',
        reasoning:
          'Three are fees and IOF ({{amount}}) that I can post now. The fourth is a received Pix of {{pix}} without a corresponding invoice; that one needs you.',
        secondary: 'Open reconciliation',
        primary: 'Post the 3 fees',
      },
      tx01: {
        kind: 'Ledger difference',
        title: 'IRRF payable does not match',
        context: 'Account 2.1.3.01 · ledger {{ledger}} × control {{control}}',
        reasoning:
          'The difference comes from a withholding changed after posting and not reposted. I suggest reprocessing this account entry.',
        secondary: 'View account',
        primary: 'Reprocess entry',
      },
    },
    activity: {
      current: {
        time: 'today 07:42',
        description:
          'I reassessed the {{controls}} controls. Three are pending and three await earlier steps.',
      },
      bank: {
        time: 'today 07:40',
        description: 'I reconciled {{entries}} Itaú entries. CX02 fell from 42 to 4 pending items.',
      },
      payables: {
        time: '13/10 21:11',
        description: 'Will published the accounts-payable assessment.',
      },
      resolved: {
        time: 'now',
        ap05: 'I settled the energy accrual against the final bill.',
        cx02: 'I posted the pending Banco Inter fees.',
        tx01: 'I reprocessed the IRRF payable entry.',
      },
    },
  },
  agentReview: {
    decisionCount_one: '{{count}} decision',
    decisionCount_other: '{{count}} decisions',
    position: '{{current}} of {{total}}',
    approveShortcut: 'A',
    rejectShortcut: 'R',
    agentName: 'Bank reconciliation alchemist',
    error: "Could not load the alchemist's proposals.",
    emptyTitle: 'No proposals from the alchemist',
    emptyDescription: 'When the alchemist proposes a reconciliation or a rule, it shows here.',
    proposalsCapped: 'Showing the {{shown}} most recent of {{total}} proposals.',
    proposal: {
      kind: 'Alchemist proposal',
      approve: 'Accept',
      reject: 'Reject',
    },
    pairing: {
      columns: {
        date: 'Date',
        issueDate: 'Issued',
        dueDate: 'Due',
        detail: 'Detail',
        origin: 'Source',
        amount: 'Amount',
      },
      bankMovement: 'Bank movement',
      cardPurchase: 'Card purchase',
      bill: 'Bill',
      billNumber: 'Invoice {{number}}',
      noBillNumber: 'No number',
      noDescription: 'No description',
      unknownVendor: 'Unnamed vendor',
      openBill: 'Open bill',
      paymentOf: 'Payment · {{status}}',
      paymentOn: 'Paid on {{date}}',
      paymentScheduledFor: 'Scheduled for {{date}}',
      match: {
        title: 'Reconcile – {{vendor}}: {{amount}}',
      },
      evidence: {
        other: 'Alchemist proposal',
        exact: {
          connector: 'Exact amount',
          reason: "The movement's amount equals the bill's open amount.",
        },
        foreign_exact: {
          connector: 'Exchange rate difference',
          reason:
            'The receipt has the same foreign-currency amount on both sides. The difference in reais is exchange variation.',
        },
        document_penalty: {
          connector: 'Bill + boleto charges',
          reason: 'The payment covers the bill and the charges printed on the boleto.',
        },
        vendor_rule: {
          connector: 'Vendor rule',
          reason: 'The difference follows the rule approved for this vendor.',
        },
        paid_payment: {
          connector: 'Payment already recorded',
          reason:
            'The bill already has a payment recorded for this amount. The movement confirms that payment.',
        },
        processing_payment: {
          connector: 'Payment in progress',
          reason:
            'The bill has a payment in progress for this amount. The movement confirms that payment.',
        },
        rule_pending: {
          connector: 'Rule under review',
          reason: 'The difference follows a vendor rule that still waits for your approval.',
        },
      },
      adjustment: {
        IOF: 'IOF {{amount}}',
        JUROS: 'interest {{amount}}',
        MULTA: 'fine {{amount}}',
        other: '{{type}} {{amount}}',
      },
      duplicate: {
        title: 'Void duplicate – {{vendor}}: {{amount}}',
        titleNoVendor: 'Void duplicate: {{amount}}',
        subtitle: 'Invoice {{number}} · issued on {{date}}',
        connector: 'Same invoice',
        keep: 'Keep',
        void: 'Void',
        sameNumber: 'Both bills have invoice {{number}}.',
        renamed: 'Invoice {{void}} is the same as {{keep}}.',
        fastTrack:
          'The bill below came by email, and the card fast track already paid the one above.',
        outcome: 'The bill marked “Void” will be voided.',
        outcomeWithDocuments_one:
          'The bill marked “Void” will be voided, and its document moves to the other one.',
        outcomeWithDocuments_other:
          'The bill marked “Void” will be voided, and its {{count}} documents move to the other one.',
      },
      movedLink: {
        title: 'Move link – {{vendor}}: {{amount}}',
        connector: 'Move the {{amount}} charge',
        reason: "Another bill of the vendor has exactly the charge's amount. Move the link to it?",
        fromEyebrow: 'Reconciled today with',
        toEyebrow: 'Will reconcile with',
        from: 'Out',
        to: 'In',
      },
    },
    toast: {
      ruleAccepted:
        "Rule approved. The lines that fit one bill only are reconciled on the alchemist's next run.",
    },
    bookAs: {
      IOF: 'IOF',
      JUROS: 'interest',
      MULTA: 'late fee',
    },
    rule: {
      kind: 'Proposed rule',
      reason_one: 'The bank reconciliation alchemist proposed a rule that resolves {{count}} line.',
      reason_other:
        'The bank reconciliation alchemist proposed a rule that resolves {{count}} lines.',
      subtitle: 'Amount paid = bill amount × {{factor}}. The difference is booked as {{bookAs}}.',
      subtitleNoGap: 'Amount paid = bill amount. No line has a difference.',
      splitAuto_one:
        '{{count}} line reconciles on its own, if it fits the limit of {{max}} per run.',
      splitAuto_other:
        '{{count}} lines reconcile on their own, if they fit the limit of {{max}} per run.',
      splitChoose_one:
        '{{count}} has another bill that also fits and stays here for you to choose.',
      splitChoose_other:
        '{{count}} have another bill that also fits and stay here for you to choose.',
      splitApprove_one: '{{count}} is over a limit of the agent and comes back for you to approve.',
      splitApprove_other:
        '{{count}} are over a limit of the agent and come back for you to approve.',
      splitShadow:
        'The agent is in shadow mode: no line reconciles on its own. All of them stay here as proposals.',
      viewLines_one: 'View the line',
      viewLines_other: 'View the {{count}} lines',
      approve: 'Approve the rule',
      reject: 'Reject',
      rejectConfirm: {
        title: 'Reject the {{vendor}} rule?',
        description:
          'The alchemist will not suggest this rule for {{vendor}} again. None of the {{count}} lines is reconciled. You can reconcile them by hand in bank reconciliation.',
        confirm: 'Reject the rule',
        cancel: 'Back',
      },
    },
    dialog: {
      title: '{{vendor}} rule',
      summaryAuto_one: '{{count}} reconciles on its own',
      summaryAuto_other: '{{count}} reconcile on their own',
      summaryChoose_one: '{{count}} you choose',
      summaryChoose_other: '{{count}} you choose',
      summaryApprove_one: '{{count}} you approve',
      summaryApprove_other: '{{count}} you approve',
      summaryAllAuto_one: 'The line reconciles on its own',
      summaryAllAuto_other: 'All {{count}} lines reconcile on their own',
      runLimit:
        'The agent reconciles up to {{max}} lines per run on its own, counting all its rules and matches. Lines over that come back as proposals.',
      columns: {
        charge: 'Amount paid',
        bill: 'Bill',
        gap: 'Difference ({{bookAs}})',
        result: 'Result',
      },
      outcome: {
        auto: 'Reconciles on its own',
        approve: 'You approve',
        choose: 'You choose',
      },
      capReason: {
        amount_cap: 'Over the per-charge limit: comes back as a proposal',
        amount_unknown: 'No rate for the day to check the limit: comes back as a proposal',
        count_cap: 'Over the limit of matches per run: comes back as a proposal',
      },
      otherBill: 'Another bill also fits: {{amount}} ({{date}})',
      otherBillNoDate: 'Another bill also fits: {{amount}}',
      close: 'Close',
    },
  },
  alchemistsCard: {
    title: 'Your alchemists',
    description: 'The agents that work for you and the last run of each one.',
    neverRan: 'Has not run yet.',
    running: 'Running now',
    loading: 'Loading alchemists…',
    error: 'Could not load the alchemists.',
    emptyTitle: 'No alchemist turned on',
    emptyDescription: 'When an agent is turned on for this company, it shows here.',
    openRuns: 'See the runs of the {{name}} alchemist',
    openLastRun: 'See the last run of the {{name}} alchemist',
    openProposals_one: '{{count}} proposal for you',
    openProposals_other: '{{count}} proposals for you',
    unknownAgent: 'Alchemist',
    agents: {
      reconciliation: {
        name: 'Reconciliation',
        role: 'Matches the bank statement with the entries.',
      },
    },
  },
  agentRuns: {
    title: 'Agent runs',
    subtitle: 'What the reconciliation agent read and decided, run by run.',
    modeSwitch: {
      label: 'Live mode',
      loading: 'Loading the agent mode',
      error: 'Could not read the agent mode.',
      off: 'The agent is off for this company.',
      noPermission: 'Only people who can reconcile change the agent mode.',
      noPermissionLive: 'Only people who can reconcile and approve vendor rules turn on live mode.',
      default: 'Shadow mode: the default. Nobody has changed the mode yet.',
      changedBy: 'Changed by {{name}} on {{date}}',
      confirmLive: {
        title: 'Turn on live mode?',
        description:
          'The agent will settle the safe pairs by itself. The rest stay proposals for you.',
        amountCap: 'Up to {{amount}} per match.',
        countCap_one: 'At most {{count}} match per run.',
        countCap_other: 'At most {{count}} matches per run.',
        closedPeriods: 'Never in a closed period.',
        nextRun: 'It applies from the next run. A run in progress does not change.',
        audit: 'The change is recorded with your name.',
        confirm: 'Turn on live mode',
      },
      confirmShadow: {
        title: 'Go back to shadow mode?',
        description:
          'The agent will only propose matches. It settles nothing by itself. It applies from the next run, and the change is recorded with your name.',
        confirm: 'Go back to shadow mode',
      },
      refused: {
        FLEET_AGENT_OFF: 'The agent is off for this company.',
        FLEET_PERMISSION_REQUIRED: 'You do not have permission to change the agent mode.',
      },
    },
    story: {
      trigger: {
        MANUAL: 'Manual run',
        SCHEDULED: 'Scheduled run',
      },
      dateLabel: '{{trigger}} · {{date}}',
      headline: {
        proposed_one:
          'The agent analysed {{candidates}} transactions and proposed {{count}} match.',
        proposed_other:
          'The agent analysed {{candidates}} transactions and proposed {{count}} matches.',
        actedAndProposed:
          'The agent analysed {{candidates}} transactions, settled {{acted}} and proposed {{proposed}}.',
        nothing: 'The agent analysed {{candidates}} transactions and found no safe pair.',
        running: 'The agent is analysing the transactions.',
        failed: 'The run stopped before it finished.',
        skipped: 'The run did not start.',
        stoppedBudget: 'The agent stopped at the work limit for this run.',
      },
      summary: {
        rejected_one: '{{count}} pair was rejected by the check.',
        rejected_other: '{{count}} pairs were rejected by the check.',
        noVerdict_one: 'For {{count}} transaction the model gave no verdict.',
        noVerdict_other: 'For {{count}} transactions the model gave no verdict.',
        shadow: 'In shadow mode nothing was settled on its own: you decide each proposal.',
        live: 'In live mode the agent settled only what was safe.',
        duration: 'It took {{duration}}.',
        running: 'This page updates on its own until the run ends.',
        failedDecided_one: 'The agent decided {{count}} transaction before it stopped.',
        failedDecided_other: 'The agent decided {{count}} transactions before it stopped.',
      },
      stopReason: {
        abandoned: 'The run stalled without finishing and was closed.',
        notQueued: 'The run never started. Run it again in a moment.',
        workerLost: 'The server restarted in the middle of the run.',
        other: 'The run stopped because of an internal error.',
      },
      // A no-break space keeps each number on the line of its unit.
      duration: {
        seconds: '{{seconds}}\u00a0s',
        minutes: '{{minutes}}\u00a0min\u00a0{{seconds}}\u00a0s',
        hours: '{{hours}}\u00a0h\u00a0{{minutes}}\u00a0min',
      },
      gauge: {
        title: 'Candidates analysed in this run',
        judged: '{{judged}} of {{candidates}} analysed',
      },
      flow: {
        title: 'The path of this run',
        sourceHeading: 'What the agent read',
        stageHeading: 'What it decided',
        outputHeading: 'Turned to gold',
        outputDetailLive: 'Settled by the agent',
        outputDetailShadow: 'Shadow mode: nothing settles on its own',
        pending: 'wait for you in Pending',
        nonePending: 'Nothing waits for you',
        unavailable: 'Data unavailable',
        sources: {
          candidates: 'Candidates',
          byType: { BANK_TX: 'Bank transactions', CARD_ITEM: 'Card transactions' },
          other: 'Other items',
          neverAgain: 'Already rejected before',
        },
        stages: {
          proposed: 'Proposed',
          rejected: 'Rejected',
          noVerdict: 'No verdict',
          declinedUnchanged: 'Declined before, nothing changed',
          actFailed: 'Refused by the system',
        },
      },
      side: {
        duration: 'Duration',
      },
      agents: {
        reconciliation: 'Bank reconciliation agent',
      },
      decisionsSubtitle: 'Every transaction the agent looked at, and why.',
      dateLabelMode: '{{trigger}} · {{date}} · {{mode}}',
      openPending: 'Open Pending',
      reviewRule: 'Review rule',
      columns: { transaction: 'Transaction', counterpart: 'Bill' },
      origin: { BANK_TX: 'Bank', CARD_ITEM: 'Card' },
      counterpart: {
        due: '{{amount}} · due {{date}}',
        issued: '{{amount}} · issued {{date}}',
        draftRule: 'New rule for this vendor',
      },
      runs: {
        title: 'Recent runs',
        all: 'See all runs',
        counts_one: '{{count}} proposal · {{open}} open',
        counts_other: '{{count}} proposals · {{open}} open',
        none: 'No proposals',
      },
    },
    columns: {
      startedAt: 'Started',
      status: 'Status',
      acted: 'Settled',
      proposed: 'Proposals',
    },
    trigger: {
      SCHEDULED: 'Scheduled',
      MANUAL: 'Manual',
    },
    status: {
      RUNNING: 'In progress',
      SUCCEEDED: 'Finished',
      STOPPED_BUDGET: 'Stopped on budget',
      FAILED: 'Failed',
      SKIPPED: 'Did not run: daily limit',
    },
    mode: {
      off: 'Off',
      shadow: 'Shadow mode',
      live: 'Live mode',
    },
    openProposals_one: '{{count}} open',
    openProposals_other: '{{count}} open',
    emptyTitle: 'No runs yet',
    emptyDescription: 'The agent runs every day at 05:00 UTC, or on the spot with "Run now".',
    detail: {
      title: 'Agent run',
      loadError: 'Could not load the run.',
      skippedDailyLimit:
        'The scheduled run did not start: the limit of 5 runs per day (UTC) was already used.',
    },
    reasons: {
      shadow_mode: 'Shadow mode: it only proposes',
      count_cap: 'Settlement limit per run reached',
      amount_cap: 'Above the maximum amount per settlement',
      exact_amount: 'Exact amount',
      document_penalty: 'Interest and fine printed on the document',
      vendor_rule: 'Vendor rule',
      draft_vendor_rule: 'Vendor rule in draft',
      vendor_rule_pending: 'Pattern seen, rule not approved yet',
      foreign_amount_matches: 'Same foreign amount on both sides',
      foreign_gap_too_large: 'Exchange difference too large',
      same_e2e: 'Same Pix identifier',
      paid_payment_date: 'Paid payment on the same date',
      payment_still_processing: 'Payment still processing',
      payment_not_settled: 'Payment not settled',
      payment_amount_differs: 'Payment amount differs',
      payment_date_too_far: 'Payment date too far',
      unique_fitting_bill_in_window: 'The only bill that fits the window',
      judge_declined: 'The model did not recognise the pair',
      unexplained_gap: 'Unexplained difference',
      partial_payment: 'Partial payment',
      currency_mismatch: 'Different currencies',
      period_closed: 'Closed period',
      BANK_STATEMENT_CLOSED: 'Bank statement of the month is closed',
      ACCOUNTING_PERIOD_CLOSED: 'Accounting period is closed',
      movement_no_longer_open: 'The movement is no longer open',
      document_no_longer_open: 'The bill is no longer open',
      vendor_changed: 'The vendor changed',
      data_changed: 'The data changed',
      rejected_by_person: 'Rejected by a person',
      rule_needs_review: 'The rule needs review',
      rule_already_recorded: 'The rule already exists',
      gap_booking_unsupported_on_ap_settlement: 'Booking the difference is not supported',
      bill_not_approved_gl_deferred: 'Bill not approved: posting deferred',
      correction_proposal_only: 'Corrections are always proposals',
      candidate_error: 'Error analysing the candidate',
      kept_bill_gone: 'The bill to keep no longer exists',
      bill_already_void: 'The bill is already void',
      bill_no_longer_voidable: 'The bill can no longer be voided',
      bills_no_longer_the_same_invoice: 'The bills are no longer the same invoice',
      link_no_longer_current: 'The link is no longer current',
      link_changed: 'The link changed',
      linked_bill_gone: 'The linked bill no longer exists',
      target_bill_gone: 'The target bill no longer exists',
      linked_bill_matches_the_charge: 'The linked bill already matches the charge',
      target_bill_no_longer_fits: 'The target bill no longer fits',
      minedManual_one: 'Seen in {{count}} manual reconciliation',
      minedManual_other: 'Seen in {{count}} manual reconciliations',
      minedOpen_one: 'Seen in {{count}} open pair',
      minedOpen_other: 'Seen in {{count}} open pairs',
    },
    glDeferred: {
      BILL_NOT_APPROVED: 'GL waits: the bill is not approved yet',
      other: 'GL deferred',
    },
    subject: {
      kind: {
        match: 'Movement and bill',
        draft_rule: 'Reconciliation rule',
        duplicate_fast_track: 'Duplicate bill (fast-track)',
        twin_bills: 'Twin bills',
        moved_link: 'Link on the wrong bill',
      },
    },
    decisions: {
      title: 'Decisions',
      emptyTitle: 'No decisions',
      emptyDescription: 'This run did not decide any candidate.',
      shown: 'Showing {{shown}} of {{total}} decisions',
      loadMore: 'Load more',
      columns: {
        outcome: 'Outcome',
        gl: 'Ledger',
      },
      outcome: {
        ACTED: 'Settled by the agent',
        PROPOSED: 'Became a proposal',
        REJECTED: 'Refused',
        ACT_FAILED: 'The system refused',
        ACCEPTED: 'Accepted by a person',
      },
    },
  },
} as const;
